export default "__VITE_ASSET__aaf13f8e__"